import { PropsData } from "bimatter-viewer/dist/Model/Model.types";
import { api } from "..";
import { parseResponse } from "../../../utils/responseUtils";
import { store } from "../../store/store";

export const excelApi = api.injectEndpoints({
    endpoints: (builder) => ({
        exportExcelWithData: builder.mutation<string, PropsData>({
            // query: (props) => {
            //     const data = new FormData();
            //     data.append("props", new Blob([JSON.stringify(props)]));
            //     return {
            //         url: `/excel/exportExcelWithData`,
            //         method: "POST",
            //         body: data,
            //         formData: true,
            //     };
            // },
            queryFn: async (props, api, extraOptions, baseQuery) => {
                const data = new FormData();
                data.append("props", new Blob([JSON.stringify(props)]));
                const result = await baseQuery({
                    url: `/excel/exportExcelWithData`,
                    method: "POST",
                    body: data,
                    responseHandler: (response) => response.blob(),
                });
                return parseResponse(
                    result,
                    (data) => {
                        const blob = new Blob([data as BlobPart]);
                        const downloadUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = downloadUrl;
                        link.download = "file.xlsm";
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    },
                    (error) => {
                        console.error(error);
                    }
                );
            },
        }),
        exportExcel: builder.mutation<string, number>({
            queryFn: async (modelID, api, extraOptions, baseQuery) => {
                const model_id =
                    store.getState().viewerMain.models[modelID]?.model_id;
                if (!model_id) {
                    console.error(`no model with id: ${modelID}`);
                    return {
                        error: {
                            error: `no model with id: ${modelID}`,
                            status: `CUSTOM_ERROR`,
                        },
                    };
                }
                const result = await baseQuery({
                    url: "/excel/exportExcel",
                    method: "GET",
                    params: { model_id },
                    responseHandler: (response) => response.blob(),
                });
                return parseResponse(
                    result,
                    (data) => {
                        const blob = new Blob([data as BlobPart]);
                        const downloadUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = downloadUrl;
                        link.download = "file.xlsm";
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    },
                    (error) => {
                        console.error(error);
                    }
                );
            },
        }),
    }),
});
export const { useExportExcelMutation, useExportExcelWithDataMutation } =
    excelApi;
export const {
    endpoints: { exportExcel, exportExcelWithData },
} = excelApi;
